<template>
  <div
    :class="[
      client === 'client2tenant' ? 'ml-56 global-tenant-menu' : 'global-menu',
    ]"
    class="flex flex-col fixed top-0 left-0 z-60 transition-all duration-100 ease-in-out"
  >
    <!-- Central enquiry/register interest banner -->
    <div
      v-if="
        client === 'client2' &&
        (templateView === 'Home' || templateView === 'ForExhibitors')
      "
      :class="[
        'flex items-center justify-center w-full',
        { 'py-2 bg-white': !!enquiryActiveStep },
      ]"
    >
      <div
        :class="
          enquiryActiveStep === 0
            ? 'opacity-100'
            : 'opacity-0 pointer-events-none absolute'
        "
        class="w-full transition-all duration-300 ease-in-out flex items-center justify-center"
      >
        <button
          :class="[
            'w-full text-center mx-auto btn bg-expo_red text-white hover:text-black rounded-none border-transparent mb-0 text-sm',
            pageIsScrolled ? 'h-8' : 'h-14',
          ]"
          @click="enquiryActiveStep = 1"
        >
          Register your interest for 2025 stands
        </button>
      </div>

      <div
        :class="
          enquiryActiveStep === 1
            ? 'opacity-100'
            : 'opacity-0 pointer-events-none absolute'
        "
        class="flex flex-wrap sm:flex-nowrap items-center justify-center gap-4 w-4/5 sm:w-2/5 px-4 mx-auto transition-all duration-300 ease-in-out"
      >
        <div class="flex w-full">
          <input
            id="enquiryEmail"
            v-model="enquiryEmail"
            class="placeholder-truegray-700 border-truegray-300 focus:border-truegray-700 text-gray-700 focus:text-gray-700 visited:text-gray-700 focus:ring-gray-700 flex-grow px-4 m-0 outline-none focus:outline-none bg-transparent w-full h-10 font-primary focus:placeholder-truegray-300 rounded-l-lg relative bg-white border absolute w-full left-0 top-0 text-center text-sm mx-auto"
            name="enquiryEmail"
            type="email"
            autocomplete="off"
            placeholder="Enter your email address"
          />
          <button
            class="btn btn-expo-red w-16 h-10 text-sm flex-shrink-0 relative right-2 mb-0"
            @click="submitEnquiry"
          >
            <div
              class="absolute inset-0 w-full flex justify-center items-center z-20"
            >
              <lottie
                v-if="enquirySubmitting"
                :options="loadingAnimationOptions"
              />
            </div>
            <span :class="[enquirySubmitting ? 'invisible' : '']">Submit</span>
          </button>
        </div>

        <button
          class="italic underline font-bold border-none background-none text-xs"
          @click="enquiryActiveStep = 0"
        >
          Cancel
        </button>
      </div>

      <div
        v-show="enquiryActiveStep === 2"
        :class="
          enquiryActiveStep === 2
            ? 'opacity-100'
            : 'opacity-0 pointer-events-none absolute'
        "
        class="w-full transition-all duration-300 ease-in-out flex flex-col items-center justify-center text-green-500 relative"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="absolute top-1 right-3 w-4 h-4 text-truegray-700 cursor-pointer"
          @click="enquiryActiveStep = 0"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
        <div class="flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-4 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>

          <p class="text-sm">Your enquiry has been sent!</p>
        </div>

        <p class="text-truegray-700 mt-1 italic text-xs">
          The team will be in touch as soon as possible.
        </p>
      </div>
    </div>
    <!-- /Central enquiry/register interest banner -->

    <!-- @todo check template_view condition -->
    <div
      :class="[
        'flex justify-between items-center w-full px-6 lg:px-12',
        pageIsScrolled
          ? 'bg-white shadow text-black py-4'
          : 'bg-transparent text-white pt-6',
      ]"
    >
      <div
        v-show="
          client !== 'client2tenant' ||
          (client !== 'client2tenant' && pageIsScrolled) ||
          (client === 'client2' && template_view !== 'Home')
        "
        class="cursor-pointer"
        @click="goHome"
      >
        <a
          ref="expoHome"
          class="hidden"
          :href="settings.central_domain2_url"
        ></a>
        <img
          v-if="pageIsScrolled"
          class="h-[25px] sm:h-[50px]"
          src="/img/expo_symbol_blue2025.png"
          alt="careers expo logo"
        />
        <img
          v-else
          :class="['h-[32px] sm:h-[75px]']"
          src="/img/expo_symbol_white2025.png"
          alt="careers expo logo"
        />
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        :class="[
          client === 'client2tenant' && managerTemplate
            ? 'text-expo_dblue'
            : '',
        ]"
        class="h-7 w-7 hover:text-expo_red cursor-pointer ml-auto"
        viewBox="0 0 20 20"
        fill="currentColor"
        @click="toggleMenu"
      >
        <path
          fill-rule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { shared } from '../js/mixins/shared.js'
import { EventBus } from '../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'
import * as loadingAnimation from '../shared/components/loading.json'

export default {
  mixins: [shared],

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      enquiryActiveStep: 0,
      enquiryEmail: '',
      enquirySubmitting: false,
      pageIsScrolled: false,
      managerTemplate: false,
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      client: 'shared/getClient',
      templateView: 'shared/getTemplateView',
    }),

    isHomePage() {
      return this.$route.name === 'Home'
    },
  },

  watch: {
    templateView: {
      handler: function () {
        this.areWeOnManagerTemplate()
      },

      deep: true,
    },
  },

  created() {
    window.addEventListener('scroll', (e) => {
      this.checkScrollPosition(e)
    })
  },

  mounted() {
    this.areWeOnManagerTemplate()
  },

  methods: {
    areWeOnManagerTemplate() {
      let path = this.$router.history.current.path
      let result = path.includes('/manager/')
      if (result) {
        this.$set(this, 'managerTemplate', true)
      } else {
        this.$set(this, 'managerTemplate', false)
      }
    },

    goHome() {
      if (this.client === 'client2') {
        this.$router.push({ path: '/' })
      } else {
        this.$refs.expoHome.click()
      }
    },

    toggleMenu() {
      EventBus.$emit('toggleExpoMenuContent')
    },

    checkScrollPosition(e) {
      if (e.srcElement.scrollingElement.scrollTop <= 100) {
        this.$set(this, 'pageIsScrolled', false)
      } else {
        this.$set(this, 'pageIsScrolled', true)
      }
    },

    submitEnquiry() {
      this.$set(this, 'enquirySubmitting', true)

      axios
        .post('/api/expo-stand-enquiry', { email: this.enquiryEmail })
        .then((response) => {
          this.$set(this, 'enquirySubmitting', false)

          const returned = response.data

          if (returned.success) {
            EventBus.$emit('triggerAlertResponse', {
              status: 'success',
              message: 'Enquiry received!',
            })
            this.enquiryActiveStep = 2
            this.enquiryEmail = ''
          } else {
            EventBus.$emit('triggerAlertResponse', {
              status: 'error',
              message: 'Something went wrong!',
            })
          }
        })
    },
  },
}
</script>

<style scoped>
.global-menu {
  width: 100%;
}
@media screen and (min-width: 1024px) {
  .global-menu {
    width: calc(100% - 11rem);
  }
  .global-tenant-menu {
    width: calc(100% - 21rem);
  }
}
</style>
